// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'babel-polyfill';
import { Button, Input, Form, FormItem, Message, Col, Row, Header, 
    Container, Aside, Dialog, Main, Tabs, Menu, MenuItem, TabPane, 
    Table, TableColumn, Pagination, Select, Dropdown, DropdownMenu,
    Card, DropdownItem, Badge, Option, Submenu, Checkbox, CheckboxGroup } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

require('es6-promise').polyfill();

import App from '@/App';
import router from '@/router';
import store from '@/store/';
import '@/assets/iconfont.css';
import '@/css/index.css';
import i18n from '@/locale';
import ElementUI from 'element-ui'
import VueResouce from 'vue-resource'

Vue.use(ElementUI)

Vue.use(VueResouce)

Vue.config.productionTip = false

Vue.component(Button.name, Button)
Vue.component(Input.name, Input)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)
Vue.component(Col.name, Col)
Vue.component(Row.name, Row)
Vue.component(Header.name, Header)
Vue.component(Container.name, Container)
Vue.component(Aside.name, Aside)
Vue.component(Dialog.name, Dialog)
Vue.component(Main.name, Main)
Vue.component(Tabs.name, Tabs)
Vue.component(Menu.name, Menu)
Vue.component(MenuItem.name, MenuItem)
Vue.component(Submenu.name, Submenu)
Vue.component(TabPane.name, TabPane)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Pagination.name, Pagination)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Card.name, Card)
Vue.component(Badge.name, Badge)
Vue.component(Message.name, Message)    // Vue.use(Message) 会造成初次加载弹出 Message

Vue.component(Dropdown.name, Dropdown)
Vue.component(DropdownMenu.name, DropdownMenu)
Vue.component(DropdownItem.name, DropdownItem)
Vue.component(Checkbox.name, Checkbox)
Vue.component(CheckboxGroup.name, CheckboxGroup)

window.__disableNativeFetch = true

/* eslint-disable no-new */
// new Vue({
//     el: '#app',
//     router,
//     components: { App },
//     template: '<App />'
// })

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
    watch: {
         $route () {
             document.title = this.$route.meta.title || this.$route.meta.pathName
         }
    },
    created() {
        document.title = this.$route.meta.title
    },
    // methods: {
    //     checkLogin() {
    //         if (!this.getConsoleToken() 
    //             && this.$router.history.current.path != "/console/reset-password/"
    //             && this.$router.history.current.path != "/console/signup/") {
    //             console.log("=== push to login")
    //             this.$router.push('/console/login')
    //         } else {
    //             console.log(this.$router.history.current)
    //             console.log("=== already login")
    //         }
    //     },
    //     getConsoleToken() {
    //         return localStorage.getItem("consoleToken")
    //     }
    // }
})



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = null
// module chunks = 